import { render } from "./CollectionImage.vue?vue&type=template&id=97424e16"
import script from "./CollectionImage.vue?vue&type=script&lang=js"
export * from "./CollectionImage.vue?vue&type=script&lang=js"

import "./CollectionImage.vue?vue&type=style&index=0&id=97424e16&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__